export const suitRangeList = [
	{value: 1, label: 'PC上线'},
	{value: 2, label: '小程序上线'},
	{value: 3, label: '全部上线'},
]
export const isSaleList = [
	{value: '0', label: '上架'},
	{value: '1', label: '下架'},
]

//1全部  2：否   3：PC   4：小程序 默认 2
export const DicIsInsureByUrl = [
	{value: '1', label: '全部'},
	{value: '2', label: '否'},
	{value: '3', label: 'PC'},
	{value: '4', label: '小程序'},
]

export const typeList = [
	{value: '1', label: '雇主险'},
	{value: '2', label: '团意险'},
	{value: '3', label: '安责险'},
	{value: '4', label: '个意险'},
	{value: '5', label: '新市民'},
	// {value: '6', label: '其他'}
]

export const categoryNewList = [
	{value: '0', label: '1-5/6类职业'},
	{value: '1', label: '建筑行业'},
	{value: '2', label: '光伏行业'},
	{value: '3', label: '电力通信行业'},
	{value: '4', label: '钢结构安装'},
	{value: '5', label: '电梯行业'},
	{value: '6', label: '物流行业'},
	{value: '7', label: '制造行业'},
	{value: '8', label: '劳务/人资企业'},
]

export const baosiNewList = [
	{value: 1, label: '太平洋'},
	{value: 2, label: '国寿财'},
	{value: 3, label: '泰康在线'},
	{value: 4, label: '美亚'},
	{value: 5, label: '平安'},
	{value: 6, label: '利宝'},
	// {value: 9, label: '三星'},
	{value: 7, label: '阳光'},
	{value: 8, label: '人保'},
	{value: 9, label: '中银'},
	{value: 10, label: '紫金'},
	{value: 11, label: '大地'},
]

export const professionDicList = [
	{value: '1', label: '1类'},
	{value: '2', label: '2类'},
	{value: '3', label: '3类'},
	{value: '4', label: '4类'},
	{value: '5', label: '5类'},
	{value: '6', label: '6类'},
]

export const couponUseStatusList = [
	{value: 'UNUSED', label: '未使用'},
	{value: 'UNUSED_ABLE', label: '未生效'},
	{value: 'USED', label: '已使用'},
	{value: 'UNUSED_GUO', label: '已过期'},
]

//categoryList 不变
// type 改成 string 类型
// 增加字段：
//   Integer groupId; 保单公司ID
//   String picture; 图片
//   String color; 颜色

export const tableOption = {
	border: true,
	stripe: true,
	menuAlign: 'center',
	align: 'center',
	copyBtn: true,
	searchMenuPosition: 'right',
	searchMenuSpan: 18,
	labelWidth: 160,
	column: [
		{
			label: '险种id',
			prop: 'insureType',
			rules: [
				{
					required: true,
					message: '请输入险种id-insureType',
					trigger: 'blur',
				},
			],
		},
		{
			label: '方案id',
			prop: 'productId',
			rules: [
				{
					required: true,
					message: '请输入方案id-productId',
					trigger: 'blur',
				},
			],
		},
		{
			label: '产品中心id',
			prop: 'productIdCenter',
		},
		{
			label: '方案名称',
			prop: 'title',
			search: true,
			rules: [
				{
					required: true,
					message: '请输入产品名称',
					trigger: 'blur',
				},
			],
		},
		{
			label: '保险公司名称',
			prop: 'groupName',
			rules: [
				{
					required: true,
					message: '请输入保险公司名称',
					trigger: 'blur',
				},
			],
		},
		{
			label: '最低价格',
			prop: 'price',
			type: 'number',
			formatter: (row) => {
				return row.price ? row.price / 100 : 0
			},
			rules: [
				{
					required: true,
					message: '请输入价格',
					trigger: 'blur',
				},
			],
		},
		{
			label: '类型',
			prop: 'type',
			dataType: 'string',
			type: 'select',
			dicData: typeList,
			multiple: true,
		},
		{
			label: '类目',
			prop: 'categoryList',
			dataType: 'string',
			type: 'select',
			dicData: categoryNewList,
			multiple: true,
		},
		// {
		//   label: '工种',
		//   prop: 'profession',
		//   type: 'select',
		//   dicData: professionDicList,
		//   dataType: 'string',
		//   rules: [{
		//     required: true,
		//     message: '请选择工种',
		//     trigger: 'blur'
		//   }],
		//   multiple: true
		// },
		{
			label: '保险公司',
			prop: 'groupId',
			type: 'select',
			dicData: baosiNewList,
		},
		{
			label: '颜色值',
			prop: 'color',
			type: 'color',
			rules: [
				{
					required: true,
					message: '请输入颜色值',
					trigger: 'blur',
				},
			],
		},
		{
			label: '产品介绍',
			prop: 'intros',
			width: 150,
			overHidden: true,
			addDisplay: false,
			editDisplay: false,
			formatter: (row) => {
				return row.intros ? JSON.parse(row.intros).join(',') : ''
			},
			rules: [
				{
					required: true,
					message: '请输入方案列表',
					trigger: 'blur',
				},
			],
		},
		{
			label: '产品介绍',
			prop: 'introsList',
			type: 'array',
			hide: true,
			showColumn: false,
			rules: [
				{
					required: true,
					message: '请输入方案列表',
					trigger: 'blur',
				},
			],
		},
		{
			label: '方案列表',
			width: 200,
			prop: 'productPlanRelationList',
			formslot: true,
			slot: true,
			rules: [
				{
					required: true,
					message: '请输入方案列表',
					trigger: 'blur',
				},
			],
		},
		{
			label: '产品特点',
			prop: 'featuresList',
			type: 'array',
		},
		{
			label: '产品介绍小程序',
			prop: 'descWx',
		},
		{
			label: '产品特点小程序',
			prop: 'introsWx',
		},
		{
			label: '上线平台 ',
			prop: 'suitRange',
			type: 'select',
			dicData: suitRangeList,
			rules: [
				{
					required: true,
					message: '请选择上线平台',
					trigger: 'blur',
				},
			],
		},
		{
			label: '是否上架',
			prop: 'isSale',
			dataType: 'string',
			type: 'select',
			dicData: isSaleList,
			value: '1',
		},
		//insureByUrl     1全部  2：否   3：PC   4：小程序 默认 2
		{
			label: '是否通过URL投保',
			prop: 'insureByUrl',
			type: 'select',
			dicData: DicIsInsureByUrl,
			value: '2',
		},
		{
			label: '产品logo',
			prop: 'groupLogoUrl',
			type: 'upload',
			hide: true,
			showColumn: false,
			loadText: 'logo上传中，请稍等',
			listType: 'picture-img',
			propsHttp: {
				res: 'data',
			},
			// dragFile: true,
			tip: '上传同步至文件服务器',
			action: '/dist/distInsure/uploadFile',
			rules: [
				{
					required: true,
					message: '请选择上线平台',
					trigger: 'blur',
				},
			],
		},
		{
			label: '产品logo',
			prop: 'groupLogo',
			type: 'img',
			editDisplay: false,
			addDisplay: false,
		},

		{
			label: '产品logo（新）',
			prop: 'picture',
			type: 'upload',
			showColumn: false,
			loadText: 'logo上传中，请稍等',
			listType: 'picture-img',
			propsHttp: {
				res: 'data',
			},
			// dragFile: true,
			tip: '上传同步至文件服务器',
			action: '/dist/distInsure/uploadFile',
			rules: [
				{
					required: true,
					message: '请选择上线平台',
					trigger: 'blur',
				},
			],
		},
		{
			label: '排序',
			prop: 'sort',
			type: 'number',
			value: 999,
		},
		//
		// {
		//   width: 150,
		//   label: '创建时间',
		//   prop: 'createTime',
		//   type: 'datetime',
		//   format: 'yyyy-MM-dd HH:mm',
		//   valueFormat: 'yyyy-MM-dd HH:mm:ss',
		//   editDisplay: false,
		//   addDisplay: false
		// }
	],
}

export const tableListOption = (safe) => {
	return {
		border: true,
		index: true,
		indexLabel: '序号',
		stripe: true,
		align: 'center',
		addBtn: false,
		delBtn: false,
		editBtn: false,
		labelWidth: 120,
		column: [
			{
				label: '产品名称',
				prop: 'title',
				search: true,
				width: 250,
			},
			{
				label: '投保提示内容',
				prop: 'informContent',
				html: true,
			},
			{
				label: '是否开启提示',
				prop: 'informStatus',
				width: 150,
			},
		],
	}
}

export const insureTypeOption = (safe) => {
	return {
		border: true,
		stripe: true,
		menuAlign: 'center',
		align: 'center',
		labelWidth: 120,
		column: [
			{
				label: '险种ID',
				prop: 'type',
				rules: [
					{
						required: true,
						message: '请输入',
						trigger: 'blur',
					},
				],
			},
			{
				label: 'uuid',
				prop: 'uuid',
				rules: [
					{
						required: true,
						message: '',
						trigger: 'blur',
					},
				],
			},
			{
				label: '险种名称',
				prop: 'name',
				rules: [
					{
						required: true,
						message: '',
						trigger: 'blur',
					},
				],
			},
			{
				label: '险种名称缩写',
				prop: 'abbreviation',
				rules: [
					{
						required: true,
						message: '',
						trigger: 'blur',
					},
				],
			},
			{
				label: '是否不同费率',
				prop: 'hasFeeRate',
				type: 'select',
				rules: [
					{
						required: true,
						message: '',
						trigger: 'blur',
					},
				],
				dicData: [
					{
						label: '否',
						value: 0,
					},
					{
						label: '是',
						value: 1,
					},
				],
			},
		],
	}
}
